<div class="container-fluid">
  <div class="row">
    <!-- <app-list-items-widget [widgetPanelListItems]="widgetPanelListItems" [widgetPanel]="{ style: { 'max-height': '250px' } }" [title]="widgetPanelListItems.title"></app-list-items-widget> -->
    <app-widget-panel>
      <div class="container-fluid d-flex flex-column h-100">
        <div class="row">
          <div class="col-12">
            <h3 class="vive-blue text-center">Accounting Alerts</h3>
          </div>
        </div>
        <div class="row flex-grow-1">
          <div class="col-12 inner-panel rounded">
            <ul class="vive-blue_list">
              @for (alert of accountingAlertsMap | keyvalue; track alert) {
                @if (isObjectWithCount(alert.value)) {
                  <a
                    (click)="navigateToGrid(alert)"
                    class="cursor-select text-decoration-none"
                  >
                    <li class="py-1">
                      {{ alert.key }}
                      <span class="fw-semibold">({{ alert.value.count }})</span>
                    </li>
                  </a>
                } @else {
                  <li class="py-1">
                    {{ alert.key }}
                    <span class="fw-semibold">({{ alert.value }})</span>
                  </li>
                }
              }
            </ul>
          </div>
        </div>
      </div>
    </app-widget-panel>
  </div>
</div>
